// Shared guard so only one /update_access_token refresh runs at a time across
// all hook instances, and refreshes aren't repeated within a short window.

let inFlightRefresh = null;
let lastRefreshAt = 0;
const MIN_REFRESH_INTERVAL = 10000;

// task: () => Promise<boolean> — resolve true when a token was rotated.
export const runGuardedRefresh = (task) => {
  if (Date.now() - lastRefreshAt < MIN_REFRESH_INTERVAL) {
    return inFlightRefresh || Promise.resolve();
  }
  if (inFlightRefresh) {
    return inFlightRefresh;
  }
  inFlightRefresh = Promise.resolve()
    .then(task)
    .then((rotated) => {
      if (rotated) lastRefreshAt = Date.now();
    })
    .finally(() => {
      inFlightRefresh = null;
    });
  return inFlightRefresh;
};
